"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  AssistantProvider: true,
  useAssistant: true,
  AssistantSidebar: true,
  AssistantStandalone: true,
  ThreadView: true,
  ThreadHeader: true,
  ThreadHistory: true,
  FeatureCards: true,
  SuggestedPrompts: true,
  WelcomeScreen: true,
  Composer: true,
  MessageBubble: true,
  LoadingIndicator: true,
  BridgeSync: true,
  UserAvatar: true,
  AgentAvatar: true,
  FeedbackModal: true,
  ErrorCard: true,
  IncidentAnalysisCard: true,
  DataRetrievalCard: true,
  EidInsightsCard: true,
  GenericResultCard: true,
  AssistantRuntimeProvider: true,
  useExternalStoreRuntime: true
};
Object.defineProperty(exports, "AgentAvatar", {
  enumerable: true,
  get: function () {
    return _Avatar.AgentAvatar;
  }
});
Object.defineProperty(exports, "AssistantProvider", {
  enumerable: true,
  get: function () {
    return _AssistantProvider.default;
  }
});
Object.defineProperty(exports, "AssistantRuntimeProvider", {
  enumerable: true,
  get: function () {
    return _react.AssistantRuntimeProvider;
  }
});
Object.defineProperty(exports, "AssistantSidebar", {
  enumerable: true,
  get: function () {
    return _AssistantSidebar.default;
  }
});
Object.defineProperty(exports, "AssistantStandalone", {
  enumerable: true,
  get: function () {
    return _AssistantStandalone.default;
  }
});
Object.defineProperty(exports, "BridgeSync", {
  enumerable: true,
  get: function () {
    return _BridgeSync.default;
  }
});
Object.defineProperty(exports, "Composer", {
  enumerable: true,
  get: function () {
    return _Composer.default;
  }
});
Object.defineProperty(exports, "DataRetrievalCard", {
  enumerable: true,
  get: function () {
    return _StructuredCards.DataRetrievalCard;
  }
});
Object.defineProperty(exports, "EidInsightsCard", {
  enumerable: true,
  get: function () {
    return _StructuredCards.EidInsightsCard;
  }
});
Object.defineProperty(exports, "ErrorCard", {
  enumerable: true,
  get: function () {
    return _StructuredCards.ErrorCard;
  }
});
Object.defineProperty(exports, "FeatureCards", {
  enumerable: true,
  get: function () {
    return _FeatureCards.default;
  }
});
Object.defineProperty(exports, "FeedbackModal", {
  enumerable: true,
  get: function () {
    return _FeedbackModal.default;
  }
});
Object.defineProperty(exports, "GenericResultCard", {
  enumerable: true,
  get: function () {
    return _StructuredCards.GenericResultCard;
  }
});
Object.defineProperty(exports, "IncidentAnalysisCard", {
  enumerable: true,
  get: function () {
    return _StructuredCards.IncidentAnalysisCard;
  }
});
Object.defineProperty(exports, "LoadingIndicator", {
  enumerable: true,
  get: function () {
    return _LoadingIndicator.default;
  }
});
Object.defineProperty(exports, "MessageBubble", {
  enumerable: true,
  get: function () {
    return _MessageBubble.default;
  }
});
Object.defineProperty(exports, "SuggestedPrompts", {
  enumerable: true,
  get: function () {
    return _FeatureCards.SuggestedPrompts;
  }
});
Object.defineProperty(exports, "ThreadHeader", {
  enumerable: true,
  get: function () {
    return _ThreadHeader.default;
  }
});
Object.defineProperty(exports, "ThreadHistory", {
  enumerable: true,
  get: function () {
    return _ThreadHistory.default;
  }
});
Object.defineProperty(exports, "ThreadView", {
  enumerable: true,
  get: function () {
    return _ThreadView.default;
  }
});
Object.defineProperty(exports, "UserAvatar", {
  enumerable: true,
  get: function () {
    return _Avatar.UserAvatar;
  }
});
Object.defineProperty(exports, "WelcomeScreen", {
  enumerable: true,
  get: function () {
    return _WelcomeScreen.default;
  }
});
Object.defineProperty(exports, "useAssistant", {
  enumerable: true,
  get: function () {
    return _AssistantProvider.useAssistant;
  }
});
Object.defineProperty(exports, "useExternalStoreRuntime", {
  enumerable: true,
  get: function () {
    return _react.useExternalStoreRuntime;
  }
});
require("./SmartAssist.css");
var _AssistantProvider = _interopRequireWildcard(require("./AssistantProvider"));
var _AssistantSidebar = _interopRequireDefault(require("./AssistantSidebar"));
var _AssistantStandalone = _interopRequireDefault(require("./AssistantStandalone"));
var _ThreadView = _interopRequireDefault(require("./ThreadView"));
var _ThreadHeader = _interopRequireDefault(require("./ThreadHeader"));
var _ThreadHistory = _interopRequireDefault(require("./ThreadHistory"));
var _FeatureCards = _interopRequireWildcard(require("./FeatureCards"));
var _WelcomeScreen = _interopRequireDefault(require("./WelcomeScreen"));
var _Composer = _interopRequireDefault(require("./Composer"));
var _MessageBubble = _interopRequireDefault(require("./MessageBubble"));
var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));
var _BridgeSync = _interopRequireDefault(require("./BridgeSync"));
var _Avatar = require("./Avatar");
var _FeedbackModal = _interopRequireDefault(require("./FeedbackModal"));
var _StructuredCards = require("./StructuredCards");
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
var _react = require("@assistant-ui/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }